/*
 * @Descripttion:
 * @version:
 * @Author: 廖图图
 * @Date: 2022-03-10 08:45:34
 * @LastEditors: 廖图图
 * @LastEditTime: 2022-03-29 16:43:13
 */

import Vue from "vue";
import audioSrc from "@/assets/audio/alarm.mp3";

let timer = null;

Vue.prototype.voiceSound = () => {
  const audio = document.getElementById("NkAudio");
  audio.setAttribute("src", audioSrc);
  audio.play();
  timer = setInterval(() => {
    audio.play();
  }, 3000);
};
Vue.prototype.stopVoice = () => {
  clearInterval(timer);
  timer = null;
};
